import React, { Component } from 'react';

import moment from 'moment';
import { connect } from 'react-redux';
import { closeBanner, openBanner } from '../actions';

class MaintenanceNotification extends Component {
  constructor(props) {
    super(props);
    this.checkBanner();
  }

  get hasNotification() {
    const { title, message, expiry } = this.props.maintenance_banner;
    if (!title || !message || !expiry) return false;
    const expiry_date = moment(expiry, 'MM/DD/YYYY hh:mm A');
    return moment().isBefore(expiry_date);
  }

  checkBanner() {
    if (!this.hasNotification || this.props.maintenance_banner.dismissed) return false;
    this.props.openBanner();
    return true;
  }

  render() {
    const { title, message, open } = this.props.maintenance_banner;
    if (!open) return null;

    return (
      <div className='ds-banner -warning'>
        <small
          className='preamble _textAlign_center'
          data-testid='maintenance-header'
        >
          Maintenance Advisory
        </small>
        <p className='copy emphasize -base' data-test='notification-body'>
          {title}
          <br />
          {message}
        </p>
        <a
          className='dismiss'
          role='button'
          onClick={this.props.closeBanner}
          data-testid='maintenance-dismiss'
        >
          <i className='materialIcon --micro -base'> close </i>
        </a>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    maintenance_banner: state.shared.ui.maintenance_banner,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    closeBanner: () => dispatch(closeBanner()),
    openBanner: () => dispatch(openBanner()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaintenanceNotification);


// WEBPACK FOOTER //
// ./src/features/shared/containers/MaintenanceNotification.js